export const COW_STATUS_TRANSLATIONS = {
  title: "Comprendre le Statut de votre Bétail",

  howStatusUpdatesWork: {
    title: "Comment ça Fonctionne ?",
    description:
      "Nous suivons automatiquement le statut de votre bétail en fonction de ce que vous enregistrez. Chaque statut se met à jour chaque fois que vous enregistrez un événement pertinent.",
  },

  statusTypes: {
    title: "Types de Statut",

    healthy: {
      title: "En Bonne Santé",
      meaning: "Indique si votre bétail est en bonne santé actuellement.",
      becomesTrue: "Quand vous enregistrez un contrôle de santé positif",
      becomesFalse:
        "Quand vous enregistrez un contrôle de santé négatif, traitement de maladie, traitement de blessure, chirurgie, contrôle post-opératoire ou vaccination",
    },

    underTreatment: {
      title: "Sous Traitement",
      meaning:
        "Indique si votre bétail reçoit actuellement des soins médicaux ou des médicaments.",
      becomesTrue:
        "Quand vous enregistrez des soins médicaux tels que vaccinations, traitements de maladies, déparasitage, traitements de plaies, chirurgies, contrôles post-opératoires ou administration de suppléments",
      becomesFalse: "Quand vous enregistrez un contrôle de santé positif",
    },

    pregnant: {
      title: "Gestante",
      meaning: "Indique si votre bétail attend un veau.",
      becomesTrue: "Quand vous enregistrez un contrôle de gestation positif",
      becomesFalse:
        "Quand vous enregistrez un contrôle de gestation négatif, avortement, mise bas, insémination, accouplement naturel ou détection de chaleurs",
    },

    inHeat: {
      title: "En Chaleurs",
      meaning:
        "Indique si votre bétail est dans le cycle reproducteur et prêt à s'accoupler.",
      becomesTrue: "Quand vous enregistrez une détection de chaleurs",
      becomesFalse:
        "Quand vous enregistrez un contrôle de gestation positif, insémination ou accouplement naturel",
    },

    lactating: {
      title: "En Lactation",
      meaning: "Indique si votre bétail produit actuellement du lait.",
      becomesTrue: "Quand vous enregistrez le début de la lactation",
      becomesFalse:
        "Quand vous enregistrez la fin de la lactation ou le tarissement",
    },
  },

  labels: {
    whatItMeans: "Que signifie-t-il ?",
    whenItBecomesTrue: "Quand s'active-t-il ?",
    whenItBecomesFalse: "Quand se désactive-t-il ?",
  },
}
